import i18n from "@/i18n";
import store from "@/store";
import { NavigationGuardNext, Route } from "vue-router";

function guardFromComplete(to: Route, from: Route, next: NavigationGuardNext) {
  if (from.name === "orderCompleteStep") return next({ name: "orderShopStep" });
  next();
}

export default [
  {
    path: "/order",
    component: () => import("@/skeleton/order/index.vue"),
    beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext) => {
      if (!store.getters["brand/showStore"]) {
        await store.dispatch(
          "api/handleErrorSnackbar",
          i18n.t("_sentence.store_currently_unavailable_msg", {
            brand: store.state.brand?.name
          })
        );
        return next({ name: "clientDashboard" });
      }
      if (store.getters["auth/client/isAuthenticated"])
        await store.dispatch("auth/client/prepare");
      return next();
    },
    children: [
      {
        path: "",
        name: "order",
        redirect: { name: "orderShopStep" },
        component: () => import("@/components/app/global/orders/orderForm.vue"),
        props: {
          basketRoutes: require("./menu").default
        },
        meta: {
          title: "_.order",
          section: {
            header: "_.order",
            icon: "shopping-basket"
          }
        },
        children: [
          {
            path: "shop",
            name: "orderShopStep",
            component: () =>
              import("@/components/app/global/baskets/basket/shop/index.vue"),
            meta: {
              title: "_.shop"
            }
          },
          {
            path: "product",
            name: "orderProductViewStep",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/productView/index.vue"
              ),
            beforeEnter: guardFromComplete,
            meta: {
              title: "_.shop"
            }
          },
          {
            path: "basket",
            name: "orderBasketStep",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/basketView/index.vue"
              ),
            meta: {
              title: "_.basket"
            },
            beforeEnter: guardFromComplete
          },
          {
            path: "authenticate",
            name: "orderAuthenticateStep",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/authenticate/index.vue"
              ),
            beforeEnter: guardFromComplete,
            meta: {
              title: "_.authenticate"
            }
          },
          {
            path: "checkout",
            name: "orderCheckoutStep",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/checkout/index.vue"
              ),
            meta: {
              title: "_.checkout"
            },
            beforeEnter: guardFromComplete
          },
          {
            path: "complete",
            name: "orderCompleteStep",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/complete/index.vue"
              ),
            meta: {
              title: "_.complete"
            }
          }
        ]
      }
    ]
  }
];
